import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Rol } from 'src/app/interfaces/rol.interface';
import { UpdateSuscription } from 'src/app/interfaces/suscription.interface';
import { User } from 'src/app/interfaces/user.interface';
import { LoginService } from 'src/app/service/login.service';
import { UsersService } from 'src/app/service/users.service';

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.scss'],
  providers: [MessageService]
})
export class AddUsersComponent implements OnInit {
  @Input() suscriptions!: UpdateSuscription[]
  @Input() roles!: Rol[];
  
  @Output() salirAgregar = new EventEmitter<void>();

  nombre: string = "";
  apellido: string = "";
  correo: string = "";
  password: string = "";
  account!: number;
  selectedDepart!: any[];
  depart: any = []
  isEmailValid: boolean = true;
  mensajeErrorForm: any;
  cargando: boolean = false;

  estatus: boolean = true;
  usuario!: User;

  constructor(private messageService: MessageService,
    private userservice: UsersService,
    private loginservice: LoginService,
    private route: ActivatedRoute,
    private translate: TranslateService) {
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
     }

  ngOnInit(): void { 
    this.disableAutocomplete()
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  private disableAutocomplete(): void {
    document.addEventListener('DOMContentLoaded', () => {
      const fields = document.querySelectorAll('input[autocomplete="new-password"], input[autocomplete="new-email"]');
      fields.forEach((field) => {
        field.setAttribute('autocomplete', 'new-password' + Math.random()); // Cambiar el valor del atributo
      });
    });
  }

  addSingle() {
    this.cargando = true;
    let ids = [];
    for (const suscripcion of this.selectedDepart) {
      ids.push(suscripcion.id)
    }
    this.usuario = {
      name: this.nombre,
      lastName: this.apellido,
      email: this.correo,
      password: this.password,
      idrol: this.account,
      idsSubscriptions: ids,
      idCustomer: this.loginservice.chatCrmUser.idCustomer
    }

    // Obtener el parámetro de idioma
    const lang = this.route.snapshot.queryParamMap.get('lang') || 'en';

    this.userservice.agregarUsuario(this.usuario, lang)
      .then(result => {
        this.cargando = false;
        if (result.success) {
          if(result.data !== ""){
            this.messageService.add({ severity: 'warn', summary: 'Advertencia', 
            detail: result.data });
            setTimeout(()=>{this.salirAgregar.emit();}, 4500)
          }else{
            this.messageService.add({ severity: 'success', summary: this.translate.instant('SUCCESS'), 
            detail: this.translate.instant('USER_ADDED') });
          }
          this.limpiarCampos();
        }
      })
      .catch(error => {
        this.cargando = false;
        if (!error.error) {
          console.error(error)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('ERROR_USER_ADD') });
          return;
        }

        const errorResponse = error.error;

        if (errorResponse.value == -1) {
          this.mensajeErrorForm = errorResponse.data;
        } else if (errorResponse.value == 1) {
          this.messageService.add({ severity: 'error', summary: this.translate.instant('ACCOUNT_EMAIL_REGISTERED'), detail: errorResponse.message });
        }
      })
  }

  validarMensajeError(atributo: string) {
    return this.mensajeErrorForm != undefined && this.mensajeErrorForm[atributo] != undefined;
  }

  limpiarMensajeErrorForm(atributo: string){
    if(this.mensajeErrorForm[atributo] != undefined){
      this.mensajeErrorForm[atributo] = undefined;
    }
  }

  private limpiarCampos() {
    this.usuario = {
      name: '',
      lastName: '',
      email: '',
      password: '',
      idrol: 0,
      idsSubscriptions: [],
      idCustomer: this.loginservice.chatCrmUser.id
    }
    this.userservice.setUsuarioCreado();
    this.nombre = "";
    this.apellido = "";
    this.correo = "";
    this.account = 0;
    this.password = "";
    this.selectedDepart = [];
  }
}
